import React from 'react';
import { formatDateToDotWithTimeV2 } from '@repo/common';

const InvoiceBottom = ({ data, $isMobile }) => {
  const totalAmount = data?.amounts?.reduce((sum, amt) => sum + amt, 0) ?? 0;

  // KRW(계좌이체) 인보이스는 소수점 없이 "55,000 KRW", 그 외는 기존대로 "15.00 $"
  const isKrw = String(data?.currency || '').toUpperCase() === 'KRW';
  const formattedAmount = isKrw
    ? `${Math.round(totalAmount).toLocaleString('en-US')} KRW`
    : `${totalAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} $`;

  if ($isMobile) {
    return (
      <div className='flex flex-col w-full gap-2 mt-[14px]'>
        <div className='flex items-center justify-between'>
          <span className='typo-b13Strong text-text-primary'>
            Total (Incl. VAT)
          </span>
          <span className='typo-b16Strong text-text-primary whitespace-nowrap'>
            {formattedAmount}
          </span>
        </div>

        <div className='typo-b12 text-text-placeholder'>
          Payer · {data?.userName} ({data?.userEmail})
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col items-start justify-center gap-1 typo-b14 text-text-primary'>
      <div className='flex items-center gap-2'>
        <div className='text-text-placeholder'>Total amount (Incl. VAT)</div>
        <div>{formattedAmount}</div>
      </div>

      <div className='flex items-center gap-2'>
        <div className='text-text-placeholder'>Issue date</div>
        <div>{formatDateToDotWithTimeV2(data?.createdAt)}</div>
      </div>

      <div className='flex items-center gap-2'>
        <div className='text-text-placeholder'>Payer info</div>
        <div>
          {data?.userName} ({data?.userEmail})
        </div>
      </div>
    </div>
  );
};

export default InvoiceBottom;
